










import Vue from 'vue'
import gql from 'graphql-tag';
import * as _ from 'lodash';

import { browserIsSafari } from '@/helpers/browserDetector';

const userNameQuery = gql`
{
  me {
    id
    email
    firstName
    lastName
  }
}
`;

export default Vue.extend({
  name: 'UserBadge',
  props: {
      sizeMd: {
        type: Boolean,
        default: false,
      },
      positionFix: {
        type: Boolean,
        default: false,
      },
  },
  data(): {
    initials: string | undefined;
  } {
    return {
      initials: undefined,
    };
  },
  apollo: {
    initials: {
      query: userNameQuery,
      fetchPolicy: 'cache-only',
      skip(): boolean{
        return (this.$store.state.user.currentUser.id == undefined);
      },
      update(dt) {
        if (_.isEmpty(dt)) {
          return undefined;
        }
        if (dt.me.firstName || dt.me.lastName) {
          const firstNameLetter = dt.me.firstName
            ? _.toUpper(dt.me.firstName.charAt(0))
            : '';
          const lastNameLetter = dt.me.lastName
            ? _.toUpper(dt.me.lastName.charAt(0))
            : '';
          return `${firstNameLetter}${lastNameLetter}`;
        }
        if (dt.me.email) {
          return _.toUpper(dt.me.email.charAt(0));
        }
        return undefined;
      },
    },
  },
  computed: {
    ovalPositioningClass(): string | undefined {
      if (this.positionFix && browserIsSafari()) {
        return 'safari-oval-position';
      }
      return undefined;
    },
  }
})
